import { Utils } from './utils';
import { AnimatedUnderline } from './animated-underline';
import { PageScroll } from './page-scroll';
import { Newsticker } from './newsticker';

document.addEventListener('DOMContentLoaded', () => {
	new Utils();
	new AnimatedUnderline();
	new PageScroll();

	const newsticker: NodeListOf<HTMLElement> = document.querySelectorAll('.newsticker');
	newsticker.forEach((item: HTMLElement) => {
		new Newsticker(item);
	});
});
